export default __webpack_public_path__ + "assets/Reporter4.png";